import { Data } from "../../";
import { getSessionId } from "./session";
import { ContentTypes, HttpHeaders } from "../constants";
import React, { useEffect, useContext } from "react";
import { UserContext } from "../../../context/userContext";
import { UserLoginInfo } from "../../../types/context";
import { AuthDetails } from "../../../model";

type UserAgnosticKeys = "request-id" | "session-id";

type UserSpecificKeys = "Authorization" | UserAgnosticKeys;

type UnionKeyToValue<U extends string, V> = {
  [K in U]: V;
};

// tslint:disable-next-line: no-any
const getToken = (state: AuthDetails) => {
  if (!state || !state.idToken) {
    return undefined;
  }
  return state.idToken;
};

export const getUserAgnosticHeaders = () => {
  return Object.freeze<UnionKeyToValue<UserAgnosticKeys, string>>({
    "request-id": `REQ-${Data.generateUUID4()}`,
    "session-id": `TCN-${getSessionId()}`,
  });
};

// tslint:disable-next-line: no-any
export const getUserSpecificHeaders = (state: any) => {
  let token;
  if (!state) {
    token = localStorage.getItem("authToken");
  } else {
    token = getToken(state);
  }

  if (!token) {
    return null;
  }

  const userAgnosticHeaders = getUserAgnosticHeaders();

  return Object.freeze<UnionKeyToValue<UserSpecificKeys, string>>({
    ...userAgnosticHeaders,
    Authorization: `Bearer ${token}`,
  });
};

export const getBaseHeaders = (contentType?: ContentTypes) => {
  return {
    Accept: ContentTypes.JSON,
    ...(contentType && { [HttpHeaders.ContentType]: contentType }),
  };
};
